"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityDetailPanel = exports.DataQualityDetailContent = void 0;
const tslib_1 = require("tslib");
/* eslint-disable deprecation/deprecation */
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const DataQualityIndicatorSharedHelpers_1 = require("../dataQualityIndicators/DataQualityIndicatorSharedHelpers");
const DataQualityStyles_1 = require("../style/DataQualityStyles");
const DataQualityDetailGroup_1 = require("./DataQualityDetailGroup");
/**
 * TODO: note that this needs to be refactored to use the unified style "RenderAssetsIndicators"
 */
/**
 * @deprecated TFS-1478812
 */
function DataQualityDetailContent(props) {
    const anchoredWarnings = [];
    const upstreamWarnings = [];
    for (const warning of props.details) {
        if (warning.onContentItem) {
            anchoredWarnings.push(warning);
        }
        else {
            upstreamWarnings.push(warning);
        }
    }
    const renderSpacer = anchoredWarnings.length > 0 && upstreamWarnings.length > 0;
    return (react_1.default.createElement("div", { style: DataQualityStyles_1.DataQualityDetailContentStyle },
        react_1.default.createElement(DataQualityDetailGroup_1.DataQualityDetailGroup, { keyPrefix: 'anchored', details: anchoredWarnings, message: catalog_messages_1.Messages.DataQualityContainerAnchored(), linksDisabled: props.linksDisabled || false }),
        renderSpacer && react_1.default.createElement(DataQualityStyles_1.DataQualityDetailGroupSpacerDiv, null),
        react_1.default.createElement(DataQualityDetailGroup_1.DataQualityDetailGroup, { keyPrefix: 'upstream', details: upstreamWarnings, message: catalog_messages_1.Messages.DataQualityContainerUpstream(), linksDisabled: props.linksDisabled || false })));
}
exports.DataQualityDetailContent = DataQualityDetailContent;
/**
 * @deprecated TFS-1478812
 */
function DataQualityDetailPanel(props) {
    const dialogProps = {
        title: props.title || '',
        getAnchorClientRect: () => (0, DataQualityIndicatorSharedHelpers_1.getTooltipAnchorClientRect)(props.anchorEl),
        positioningBehavior: widgets_1.DialogPositioningBehavior.Anchored,
        dialogStyle: DataQualityStyles_1.DataQualityDetailPanelDialogStyle,
        dialogBodyStyle: DataQualityStyles_1.DataQualityDetailPanelDialogBodyStyle,
        anchorOrigin: {
            vertical: widgets_1.VerticalOriginOption.top,
            horizontal: props.side === 'right'
                ? widgets_1.HorizontalOriginOption.right
                : widgets_1.HorizontalOriginOption.left,
        },
        showFooter: false,
        shouldAdjustPositionOnWindowResize: true,
        testId: 'data-quality-detail-panel',
        isModal: true,
        isGlassTransparent: true,
        type: widgets_1.DialogType.Uber,
        showCloseButton: false,
        handleGlassClick: props.onCloseRequest,
        onCloseRequest: props.onCloseRequest,
        shouldReturnFocusOnClose: false,
        disableAutoFocus: true,
        stackingRootId: props.stackingRootId,
    };
    const anchoredWarnings = [];
    const upstreamWarnings = [];
    for (const warning of props.details) {
        if (warning.onContentItem) {
            anchoredWarnings.push(warning);
        }
        else {
            upstreamWarnings.push(warning);
        }
    }
    const renderSpacer = anchoredWarnings.length > 0 && upstreamWarnings.length > 0;
    return (react_1.default.createElement(widgets_1.DialogWidget, Object.assign({}, dialogProps),
        react_1.default.createElement(DataQualityDetailGroup_1.DataQualityDetailGroup, { keyPrefix: 'anchored', details: anchoredWarnings, message: catalog_messages_1.Messages.DataQualityContainerAnchored(), linksDisabled: props.linksDisabled || false }),
        renderSpacer && react_1.default.createElement(DataQualityStyles_1.DataQualityDetailGroupSpacerDiv, null),
        react_1.default.createElement(DataQualityDetailGroup_1.DataQualityDetailGroup, { keyPrefix: 'upstream', details: upstreamWarnings, message: catalog_messages_1.Messages.DataQualityContainerUpstream(), linksDisabled: props.linksDisabled || false })));
}
exports.DataQualityDetailPanel = DataQualityDetailPanel;
//# sourceMappingURL=DataQualityDetailPanel.js.map